import React from 'react';

import '../style.css';

import { ThreeBounce } from 'better-react-spinkit';

export default function LoadingCard() {
  return (
    <article className='Loading Card'>
      <div>
        <ThreeBounce color={'#CDD3D8'} scaleStart={0.4} />
      </div>
    </article>
  );
}
